import React, { useState, useEffect, useRef } from "react";
import {
  Icon,
  Button,
  Tab,
  Loader,
  Label,
  Modal,
  Form,
  TextArea,
  Message,
} from "semantic-ui-react";
import moment from "moment";

import Work from "./work";
import Personal from "./personal";
import Attachments from "./attachments";
import { usePermissionsSimplified } from "../../../../hooks/usePermissionsSimplified";
import { toast } from "react-toastify";
import { selectTranslations } from "../../../config/i18n/slice";
import { useSelector } from "react-redux";
import { CloseIcon } from "../../../../Assets/Icons/svg";
import DownloadExcelFileWithData from "../../../../services/DownloadExcelFileWithData";
import DownloadPdfFileWithData from "../../../../services/DownloadPdfFileWithData";
import { Resizable } from "re-resizable";
import DetailsViewOptions from "../../../components/common/DetailsViewOptions";
import useDeletePermissionModal from "../../../../hooks/Messages/useDeletePermissionModal";
import ReactTooltip from "react-tooltip";
import {
  getUserProfileByID,
  getUsersByID,
} from "../../../config/sharedApi/peopleApis";
import {
  approveUser,
  declineUser,
  deleteUser,
} from "../../../config/api/peopleApis";

function Preview({
  toggled,
  untoggle,
  targetedData,
  edit,
  refresh,
  setRefresh,
  setFilterOptions,
  setSearchTitle,
  setSortData,
  setModalWidth,
  modalWidth,
  setTogglePreviw,
  allIds,
  roleData,
}) {
  const { userPermissions, checkForWRPermission } = usePermissionsSimplified();
  let panes;
  const {
    setDeletePermissionModal,
    DeletePermissionModal,
  } = useDeletePermissionModal();
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const userRole = useSelector((state) => {
    if (state?.auth?.user?.role?.type) {
      return state?.auth?.user?.role?.type;
    } else {
      return "";
    }
  });
  const userId = useSelector((state) => {
    if (state?.auth?.user?.role?.id) {
      return state?.auth?.user?.role?.id;
    } else {
      return null;
    }
  });

  const organisationCurrency = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.currency;
    } else {
      return "JOD";
    }
  });

  const [deleteErrorMessage, setDeleteErrorMessage] = useState(false);
  const [DeleteSuccessModal, setDeleteSuccessModal] = useState(false);

  const [fetching, setFetchLoading] = useState(true);
  const [data, setData] = useState(null);
  const [reason, setReason] = useState("");
  const [attachmentData, setAttachmentData] = useState(null);

  const [declinedModal, setDeclinedModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [declineReason, setDeclineReason] = useState("");

  const [declinedButton, setDeclindButton] = useState(0);

  const [approveButton, setApproveButton] = useState(0);

  const [statusUpdated, setStatusUpdated] = useState(false);

  const t = useSelector(selectTranslations);

  useEffect(() => {
    setFetchLoading(true);

    const fetchData = async () => {
      const res = await getUsersByID(targetedData.id);
      if (res.status == 200) {
        setData(res.data);
        setFetchLoading(false);
      }

      if (res?.data?.userProfile) {
        setFetchLoading(false);
        const fetchData = await getUserProfileByID(targetedData.userProfile.id);

        if (fetchData) {
          setAttachmentData({
            contractCopy: fetchData.data.data.attributes.contractCopy?.data,
            personalPicture:
              fetchData.data.data.attributes.personalPicture?.data,
            passportCopy: fetchData.data.data.attributes.passportCopy?.data,
            idCopyFront: fetchData.data.data.attributes.idCopyFront?.data,
            visaCopy: fetchData.data.data.attributes.visaCopy?.data,
            covidCopy: fetchData.data.data.attributes.covidCopy?.data,
          });
          setFetchLoading(false);
        } else {
          setFetchLoading(false);
        }
      }
    };
    if (targetedData) fetchData();
  }, [targetedData, statusUpdated]);

  const [popupIsOpen, setPopupIsOpen] = useState(false);

  const popUpRef = useRef(null);

  useEffect(() => {
    document.body.addEventListener("click", (e) => {
      let execlude_ids = ["popupTrigger"];

      if (!execlude_ids.includes(e.target.id))
        setTimeout(() => setPopupIsOpen(false), 10);
    });
  }, [popUpRef]);

  const roles = [
    {
      key: 0,
      value: 5,
      text: t.people.add_modal.admin,

      description: t.people.add_modal.admin_description,
    },
    {
      key: 0,
      value: 4,
      text: t.people.add_modal.super_admin,
      description: t.people.add_modal.admin_description,
    },
    {
      key: 2,
      value: 9,
      text: t.people.add_modal.limited_admin,

      description: t.people.add_modal.limited_admin_description,
    },
    {
      key: 1,
      value: 8,
      text: t.people.add_modal.technician,

      description: t.people.add_modal.user_description,
    },

    {
      key: 3,
      value: 3,
      text: t.people.add_modal.viewer,

      description: t.people.add_modal.viewer_description,
    },
    {
      key: 2,
      value: 6,
      text: t.people.add_modal.requester,
      description: t.people.add_modal.requester_desc,
    },
  ];
  const headers = [
    { label: t.assets.table.ID, key: "id" },
    { label: t.people.table.name, key: "name" },
    { label: t.customers.table.phone, key: "mobile" },
    { label: t.jobTitle.add, key: "jobtitle" },
    { label: t.people.table.role, key: "role" },
    { label: t.people.table.teams, key: "teams" },
    { label: t.people.table.supervisor, key: "supervisor" },
    { label: t.people.table.hourly_rate, key: "hourly_rate" },
    { label: t.people.table.status, key: "status" },
    { label: t.people.table.contract_expiry_date, key: "contract_expiry_date" },
  ];

  const downloadXLS = () => {
    let csvData = [];

    let people_data = [];

    people_data.id = data.id;
    people_data.name =
      data?.firstName && data?.lastName
        ? data.firstName + data?.lastName
        : t.common.na;

    people_data.mobile = data?.userProfile?.phone
      ? `+${data?.userProfile?.phone}`
      : t.common.na;

    people_data.jobtitle = data?.userProfile?.job?.title
      ? data?.userProfile?.job.title
      : t.common.na;

    let roleData = roles.find((each) => each.value == data.role.id);

    people_data.role = data?.role.id
      ? roleData?.text || data?.role?.type
      : t.common.na;

    let assigneePeople = data.teams;
    let assignString = "";

    if (assigneePeople?.length > 0) {
      assignString = assigneePeople.map((people) => people?.name).join(", ");
    } else {
      assignString = t.common.na;
    }
    people_data.teams = assignString;

    people_data.supervisor = data?.supervisor?.firstName
      ? data?.supervisor?.firstName + " " + data?.supervisor?.lastName
      : t.common.na;

    people_data.hourRate = data.userProfile?.hourRate
      ? `${data.userProfile?.hourRate} ${organisationCurrency}`
      : t.common.na;
    people_data.status =
      data.confirmed && !data.blocked
        ? t.assets.active
        : data.blocked
        ? t.assets.inActive
        : t.people.status_options.status_pending;

    people_data.contract_expiry_date = data?.userProfile?.contractEnd
      ? moment(data?.userProfile?.contractEnd).format("DD.MM.YYYY")
      : t.common.na;

    csvData.push([
      people_data.id,
      people_data.name,
      people_data.mobile,
      people_data.jobtitle,

      people_data.role,
      people_data.teams,
      people_data.supervisor,
      people_data.hourRate,
      people_data.status,

      people_data.contract_expiry_date,
    ]);

    let csvColumnWidths = [
      { wch: 5 },
      { wch: 20 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 30 },
      { wch: 25 },
      { wch: 15 },
      { wch: 15 },

      { wch: 25 },
    ];
    DownloadExcelFileWithData(
      headers,
      csvData,
      csvColumnWidths,
      data?.firstName || "Single-People"
    );
  };

  const generatePDF = () => {
    let csvData = [];

    let people_data = [];

    people_data.id = data.id;
    people_data.name =
      data?.firstName && data?.lastName
        ? data.firstName + data?.lastName
        : t.common.na;

    people_data.mobile = data?.userProfile?.phone
      ? `+${data?.userProfile?.phone}`
      : t.common.na;

    people_data.jobtitle = data?.userProfile?.job?.title
      ? data?.userProfile?.job.title
      : t.common.na;

    let roleData = roles.find((each) => each.value == data.role.id);

    people_data.role = data?.role.id
      ? roleData?.text || data?.role?.type
      : t.common.na;

    let assigneePeople = data.teams;
    let assignString = "";

    if (assigneePeople?.length > 0) {
      assignString = assigneePeople.map((people) => people?.name).join(", ");
    } else {
      assignString = t.common.na;
    }
    people_data.teams = assignString;

    people_data.supervisor = data?.supervisor?.firstName
      ? data?.supervisor?.firstName + " " + data?.supervisor?.lastName
      : t.common.na;

    people_data.hourRate = data.userProfile?.hourRate
      ? `${data.userProfile?.hourRate} ${organisationCurrency}`
      : t.common.na;
    people_data.status =
      data.confirmed && !data.blocked
        ? t.assets.active
        : data.blocked
        ? t.assets.inActive
        : t.people.status_options.status_pending;

    people_data.contract_expiry_date = data?.userProfile?.contractEnd
      ? moment(data?.userProfile?.contractEnd).format("DD.MM.YYYY")
      : t.common.na;

    csvData.push([
      people_data.id,
      people_data.name,
      people_data.mobile,
      people_data.jobtitle,

      people_data.role,
      people_data.teams,
      people_data.supervisor,
      people_data.hourRate,
      people_data.status,

      people_data.contract_expiry_date,
    ]);
    const columnWidths = [, , , , , , , 20, , , , ,];

    DownloadPdfFileWithData(headers, csvData, t.people.add, [], "A3");
  };

  panes = [
    {
      menuItem: t.people.personal_info_form.work_info,
      pane: {
        key: "work",
        content: (
          <div className="pane-body">
            <Work
              targetedData={data}
              setTargetData={setData}
              allIds={allIds}
              untoggle={untoggle}
              setRefresh={setRefresh}
              roleData={roleData}
              setFilterOptions={setFilterOptions}
              setSearchTitle={setSearchTitle}
              setSortData={setSortData}
              setTogglePreviw={setTogglePreviw}
              supervisorData={targetedData?.supervisor}
              attachmentData={attachmentData}
              createdByUserData={targetedData?.createdByUser}
              updatedByUserData={targetedData?.updatedByUser}
            />
          </div>
        ),
      },
    },

    {
      menuItem: t.people.personal_info_form.personal_info,
      pane: {
        key: "personal",
        content: (
          <div className="pane-body">
            <Personal
              targetedData={data}
              setTargetData={setData}
              untoggle={untoggle}
              setRefresh={setRefresh}
              refresh={refresh}
              attachmentData={attachmentData}
              createdByUserData={targetedData?.createdByUser}
              updatedByUserData={targetedData?.updatedByUser}
              setFilterOptions={setFilterOptions}
              setSearchTitle={setSearchTitle}
              setSortData={setSortData}
              setTogglePreviw={setTogglePreviw}
            />
          </div>
        ),
      },
    },
    {
      menuItem: t.people.attachments_form.attachment_title,
      pane: {
        key: "attachments",
        content: (
          <div className="pane-body">
            <Attachments targetedData={data} />
          </div>
        ),
      },
    },
    // {
    //   menuItem: t.workOrders.details_view.log,
    //   pane: {
    //     key: 'log',
    //     content: (
    //       <div className="pane-body">
    //         <Logs targetedData={data} />
    //       </div>
    //     ),
    //   },
    // },
  ];
  if (userRole == "super_admin" && data?.role?.id !== 6) {
    panes = [
      {
        menuItem: t.people.personal_info_form.work_info,
        pane: {
          key: "work",
          content: (
            <div className="pane-body">
              <Work
                targetedData={data}
                setTargetData={setData}
                allIds={allIds}
                untoggle={untoggle}
                setRefresh={setRefresh}
                roleData={roleData}
                setFilterOptions={setFilterOptions}
                setSearchTitle={setSearchTitle}
                setSortData={setSortData}
                setTogglePreviw={setTogglePreviw}
                supervisorData={targetedData?.supervisor}
                attachmentData={attachmentData}
                createdByUserData={targetedData?.createdByUser}
                updatedByUserData={targetedData?.updatedByUser}
              />
            </div>
          ),
        },
      },

      {
        menuItem: t.people.personal_info_form.personal_info,
        pane: {
          key: "personal",
          content: (
            <div className="pane-body">
              <Personal
                targetedData={data}
                setTargetData={setData}
                untoggle={untoggle}
                setRefresh={setRefresh}
                refresh={refresh}
                attachmentData={attachmentData}
                createdByUserData={targetedData?.createdByUser}
                updatedByUserData={targetedData?.updatedByUser}
                setFilterOptions={setFilterOptions}
                setSearchTitle={setSearchTitle}
                setSortData={setSortData}
                setTogglePreviw={setTogglePreviw}
              />
            </div>
          ),
        },
      },
      {
        menuItem: t.people.attachments_form.attachment_title,
        pane: {
          key: "attachments",
          content: (
            <div className="pane-body">
              <Attachments targetedData={data} />
            </div>
          ),
        },
      },
      // {
      //   menuItem: t.people.security,
      //   pane: {
      //     key: 'security',
      //     content: (
      //       <div className="pane-body">
      //         <Security
      //           targetedData={data}
      //           setTargetData={setData}
      //           setStatusUpdated={setStatusUpdated}
      //           statusUpdated={statusUpdated}
      //         />
      //       </div>
      //     ),
      //   },
      // },
      // {
      //   menuItem: t.workOrders.details_view.log,
      //   pane: {
      //     key: 'log',
      //     content: (
      //       <div className="pane-body">
      //         <Logs targetedData={data} />
      //       </div>
      //     ),
      //   },
      // },
    ];
  }

  const declineUserHandler = async () => {
    setDeclindButton(1);
    const res = await declineUser(targetedData.id, declineReason);

    if (res.status == 200) {
      setDeclindButton(0);

      setTimeout(() => {
        setDeclinedModal(false);
        setStatusUpdated(!statusUpdated);
        setDeclineReason("");
      }, 500);
    }
  };

  const approveUserHandler = async () => {
    setApproveButton(1);
    const res = await approveUser(targetedData.id, declineReason);

    if (res.status == 200) {
      setApproveButton(0);
      setStatusUpdated(!statusUpdated);
    }
  };
  const toggleDeleteSuccessModal = (data) => {
    setDeleteSuccessModal(!DeleteSuccessModal);
    if (data) {
      untoggle();
    }
  };

  const deleteHandler = async () => {
    const response = await deleteUser(targetedData.id, reason);

    if (response.status == 200) {
      setDeleteErrorMessage(false);
      setSortData([]);
      setFilterOptions({
        role: [],
        supervisors: [],
        jobTitle: [],
        teams: [],
        status: [],
        rate: {
          from: null,
          to: null,
        },
      });
      setSearchTitle("");
      toast.success(t.people.security_form.preson_deleted);
      toggleDeleteSuccessModal("close");
    } else if (response.status == 400) {
      setDeleteErrorMessage(true);
      toast.error(t.people.security_form.person_not_deleted);
      toggleDeleteSuccessModal();
    } else {
      toast.error(t.common.something_wrong);
    }
    setReason("");
  };

  const handleEdit = () => {
    data?.userProfile?.id
      ? edit(data?.userProfile?.id)
      : toast.error("User Profile doesn't exists");
    setPopupIsOpen(false);
  };

  const handleDelete = () => {
    setDeleteModal(true);
    setPopupIsOpen(false);
    setDeletePermissionModal(true);
  };

  return (
    <>
      <div
        clearing
        style={{ maxWidth: `${modalWidth}px` }}
        className={
          toggled
            ? "aside-modal preview active procedure"
            : "aside-modal preview procedure"
        }
      >
        <Resizable
          size={{ width: modalWidth, height: "auto" }}
          minWidth={"514px"}
          onResize={(e, direction, ref, d) => {
            setModalWidth(ref.offsetWidth);
          }}
        >
          {data?.blocked ? (
            <div className="alert mb-5 mt-5">
              {t.people.personal_info_form_edit.user_blocked}
            </div>
          ) : (
            ""
          )}
          <div className="modal-header detail-header">
            <div className="flexbox justify-between align-center">
              <div className="name">
                {t.people.title} #{data?.countId}
              </div>

              <div className="flexbox align-center workorder-header-buttons">
                <DetailsViewOptions
                  generatePDF={generatePDF}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  isDelete={
                    targetedData?.role?.type === "super_admin"
                      ? null
                      : (userRole == "super_admin" &&
                          targetedData?.role?.id != userId &&
                          targetedData?.role?.type !== "super_admin") ||
                        (userPermissions?.people?.delete &&
                          (targetedData?.role?.type != "admin" ||
                            targetedData?.role?.type !== "super_admin") &&
                          targetedData?.role?.id != userId)
                  }
                  isEdit={
                    (userRole == "admin" || userRole == "limited_admin") &&
                    targetedData?.role?.type === "super_admin"
                      ? null
                      : userRole == "limited_admin" &&
                        targetedData?.role?.type === "admin"
                      ? null
                      : userPermissions?.people?.edit ||
                        checkForWRPermission(targetedData?.id) ||
                        (targetedData?.role?.type === "super_admin" &&
                          userRole == "super_admin")
                  }
                />
                <span
                  data-tip
                  data-for={`tooltip-close`}
                  className={`procedure-header-button c-pointer ${
                    selectedLanguage == "en" ? "ml-1" : "mr-3"
                  }`}
                  onClick={() => {
                    untoggle();
                  }}
                >
                  <CloseIcon />
                  <ReactTooltip
                    id={`tooltip-close`}
                    place="bottom"
                    effect="solid"
                  >
                    {t.common.close}
                  </ReactTooltip>
                </span>
              </div>
            </div>
          </div>
          <div className="body">
            {data?.declined && data?.declinedReason.length > 0 ? (
              <Message negative attached="bottom" className="mb-2 mx-5">
                <Icon name="dont" color="red" />
                {t.people.security_form.decline_reason}:{" "}
                <b>{data?.declinedReason}</b>
              </Message>
            ) : (
              ""
            )}
            {data ? (
              <Tab
                panes={panes}
                className={"location-tab pb-4"}
                renderActiveOnly={false}
              />
            ) : (
              <Loader active inline="centered">
                {t.common.loading}
              </Loader>
            )}
          </div>
        </Resizable>
      </div>
      <div
        className={
          toggled ? "aside-modal-background active" : "aside-modal-background"
        }
        onClick={() => {
          setData();
          untoggle();
        }}
      ></div>

      <Modal
        size="tiny"
        open={declinedModal}
        onClose={() => setDeclinedModal(false)}
      >
        <Modal.Content>
          <Form className="mb-5">
            <Form.Field>
              <label className="label-item">
                {t.people.security_form.decline_reason_spacify}
              </label>
              <TextArea
                autoComplete="new-password"
                value={declineReason}
                onChange={(e) => setDeclineReason(e.target.value)}
                rows={2}
                fluid
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setDeclinedModal(false)}>
            {t.common.cancel}
          </Button>
          <Button
            negative
            onClick={declineUserHandler}
            loading={declinedButton > 0}
          >
            {t.people.personal_info_form_edit.decline_btn}
          </Button>
        </Modal.Actions>
      </Modal>

      <DeletePermissionModal
        yesCallback={() => {
          deleteHandler();
        }}
        title={t.people.title}
        setReason={setReason}
        reason={reason}
      >
        <span>{t.people.personal_info_form_edit.delete_person_statement}</span>
      </DeletePermissionModal>
    </>
  );
}

export default Preview;
